import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import google from './plugins/google';
import moment from './plugins/moment';
import vuetify from './plugins/vuetify';
import axios from './plugins/axios';
import './plugins/polyfills/requestIdleCallback';
import './plugins/directives/custom-directives';
import { UmbracoService, UserService } from './services';
import { User } from './services/models';
import { currency, dateFormatString } from './utils/filters';
import { mainHeaderMixins } from './main.mixins';
import wait from './wait';

// Sentry Logging service
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";

// import interceptorsSetup from "@/services/helpers/ServiceCancellable";
// interceptorsSetup();

if (window.CONFIG.environment === 'PROD') {
	Sentry.init({
		dsn: "https://0b8e9e02f8e04d0f8570c0abb07378f5@o464411.ingest.sentry.io/5493920",
		environment: window.CONFIG.environment === 'PROD' ? 'production' : 'test',
		integrations: [
		new VueIntegration({
			Vue,
			tracing: true,
		}),
		new Integrations.BrowserTracing(),
		],
	
		// We recommend adjusting this value in production, or using tracesSampler
		// for finer control
		tracesSampleRate: 1.0,
	});
}

// Configurations
Vue.config.productionTip = false;
// Set portal url used by header
Object.assign(window.CONFIG, {PORTAL_URL: process.env.VUE_APP_FIXIT_NO_URL})
// Global properties
Vue.prototype.$config = window.CONFIG;
Vue.prototype.$eventBus = new Vue();
Vue.prototype.$google = Object.assign(window.CONFIG.google, google); // Google analytics
Vue.prototype.$moment = moment;
Vue.prototype.$umbraco = new Proxy(window.UMBRACO, {
	get: (obj, prop) => {
		if (prop in UmbracoService) return UmbracoService[prop];
		return obj[prop];
	}
});
window.CONFIG.user = new User(window.CONFIG.user);
Vue.prototype.$user = Vue.observable(window.CONFIG.user)
//  new Proxy(window.CONFIG.user, {
// 	get: (obj, prop) => {
// 		if (prop in UserService) return UserService[prop];
// 		return obj[prop];
// 	}
// });

// Error handling
if (process.env.NODE_ENV === 'production') {
	Vue.config.errorHandler = (err, vm, info) => {
		// err: error trace
		// vm: component in which error occured
		// info: Vue specific error information such as lifecycle hooks, events etc.
		// error.siteId = window.CONFIG.user.CurrentSiteId;
		// error = JSON.parse(JSON.stringify(error, Object.getOwnPropertyNames(error)));
		// Send error to Google Analytics
		const mobile = window.CONFIG.user ? window.CONFIG.user.mobile : 'user-not-logged-in';
		google.sendEvent('Error', err.message, err.stack, info + ' - Mobile=' + mobile);
		// Open client that try to navigate to anothe module/chunk need a refresh.
		// Loading chunk chunk-3021fd36 failed.
		if (/Loading chunk .* failed./i.test(err.message)) {
			//window.location.reload();
		}
		return false;
	};
}

// Global filters
Vue.filter('currency', currency);
Vue.filter('dateFormatString', dateFormatString);
Vue.config.performance = true;
// Mount
new Vue({
	mixins: [mainHeaderMixins],
	router,
	store,
	wait,
	vuetify,
	stripe: null, // Reactive placeholder for when Stripe is loaded.
	render: h => h(App)
}).$mount('#app');
